var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FieldBasics } from '@/components/mambas';
import lodash from 'lodash';
import { Component, Inject, Mixins } from 'vue-property-decorator';
let default_1 = class default_1 extends Mixins(FieldBasics) {
    get min() {
        return lodash.get(this._fieldProps, 'min', 0);
    }
    get max() {
        return lodash.get(this._fieldProps, 'max', 100000000);
    }
    async mounted() {
        // this.onRequest();
        if (this.debug) {
            console.log('');
            console.group(`Field ~ ${this.entityKey} ${this._name} `);
            console.log(this);
            console.groupEnd();
        }
    }
};
__decorate([
    Inject()
], default_1.prototype, "formState", void 0);
__decorate([
    Inject()
], default_1.prototype, "PageEntity", void 0);
__decorate([
    Inject({ default: Number })
], default_1.prototype, "formType", void 0);
default_1 = __decorate([
    Component({ components: {} })
], default_1);
export default default_1;
